import React, { useCallback, useState } from "react";
import { useBuyCart } from "@/Hooks/BuyCart/BuyCart";
import { createContext, useContext } from "react";
import type { MFormUserCart } from "@/Models/MUser/MFormUserCart";

type TicketContexType = {
  SendBuyCartV2: (
    idSkus: string[],
    Country: string,
    City: string,
    ZipCode: number,
    Cupon: string
  ) => void;
  UpdateDateUser: (user: MFormUserCart) => void;
  UserData: MFormUserCart;
};

const TicketContext = createContext<TicketContexType | undefined>(undefined);

export const ContextTicketCartProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { SendBuyCartV2 } = useBuyCart();
  const [formUserData, setFormUserData] = useState<MFormUserCart>({
    FirstName: "",
    LastName: "",
    CompanyName: "",
    Email: "",
    CountryCode: "",
    Phone: "",
    Address: "",
    PostalCode: "",
  });

  const UpdateDateUser = useCallback(
    (user: MFormUserCart) => {
      setFormUserData({
        ...formUserData,
        FirstName: user.FirstName,
        LastName: user.LastName,
        CompanyName: user.CompanyName,
        Email: user.Email,
        Phone: user.Phone,
        Address: user.Address,
        PostalCode: user.PostalCode,
      });
    },
    [formUserData]
  );

  const UserData = formUserData;

  return (
    <TicketContext.Provider value={{ SendBuyCartV2, UpdateDateUser, UserData }}>
      {children}
    </TicketContext.Provider>
  );
};

export const useContextTicketProvider = () => {
  const context = useContext(TicketContext);
  if (!context) {
    throw new Error(
      "useContextTicketProvider must be used within a  ContextTicketCartProvider"
    );
  }
  return context;
};
